/**
 * Matches selector polyfill
 */

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
    Element.prototype.closest = (s) => {
        const el = this
        let ancestor = this
        if (!document.documentElement.contains(el)) return null
        do {
            if (ancestor.matches(s)) return ancestor
            ancestor = ancestor.parentElement
        } while (ancestor !== null)
        return null
    }
}

